import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload = z.any()
export type TagsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload = z.infer<typeof tagsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload>

export const descriptionGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload = z.any()
export type DescriptionGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload = z.infer<typeof descriptionGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload>

export const paramsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload = z.object({ "municipalityId": z.string().uuid(), "documentId": z.string().uuid() })
export type ParamsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload = z.infer<typeof paramsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload>

export const responseGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload = z.any()
export type ResponseGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload = z.infer<typeof responseGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload>

interface IGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload extends BaseMethodType {
  tags: TagsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload,
  description: DescriptionGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload,
  params: ParamsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload,
  response: ResponseGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload
}
export const URL = '/documents/municipalities/:municipalityId/documents/:documentId/download'
export const validation = {
  get: {
    tags: tagsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload,
    description: descriptionGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload,
    params: paramsGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload,
    response: responseGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload
  }
}
export interface DocumentsMunicipalities_municipalityIdDocuments_documentIdDownload extends BaseRouteType {
  get: IGetDocumentsMunicipalities_municipalityIdDocuments_documentIdDownload
}